export default "__VITE_ASSET__49e29450__"